import { DEALER_SEARCH_VALUES } from '../constants/header-account-features';

export const getFilteredStoreLocations = (
  restrictedStores,
  storeData,
  searchValue
) => {
  if (
    !restrictedStores ||
    restrictedStores?.length < 1 ||
    (typeof searchValue === 'string' &&
      DEALER_SEARCH_VALUES.includes(searchValue))
  ) {
    return storeData;
  }

  const filteredStores = (storeData?.locations ?? []).filter(
    (store) => !restrictedStores.includes(store.storeId)
  );
  return {
    ...storeData,
    locations: filteredStores,
    recordSetTotal: filteredStores?.length
  };
};
